__turbopack_context__.v({
  "button": "Button-module-scss-module__VLzsWq__button",
  "compact": "Button-module-scss-module__VLzsWq__compact",
  "copyAffordance": "Button-module-scss-module__VLzsWq__copyAffordance",
  "copyIcon": "Button-module-scss-module__VLzsWq__copyIcon",
  "copyShell": "Button-module-scss-module__VLzsWq__copyShell",
  "ghost": "Button-module-scss-module__VLzsWq__ghost",
  "primary": "Button-module-scss-module__VLzsWq__primary",
  "secondary": "Button-module-scss-module__VLzsWq__secondary",
  "tertiary": "Button-module-scss-module__VLzsWq__tertiary",
});
